$.fn.isOnScreen = function (buffer = 300) {
  var win = $(window);

  var viewport = {
    top: win.scrollTop() - buffer,
    left: win.scrollLeft() - buffer,
  };
  viewport.right = viewport.left + win.width() + (buffer * 2);
  viewport.bottom = viewport.top + win.height() + (buffer * 2);

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return !(
    viewport.right < bounds.left ||
    viewport.left > bounds.right ||
    viewport.bottom < bounds.top ||
    viewport.top > bounds.bottom
  );
};

// OLD JQUERY

function loadPoductColors(cur, index) {
  if (!cur.hasClass("prod-loaded")) {
    cur.addClass("prod-loaded");

    var productTag = cur.data("prod-tags");
    
    // Parse de color map
    const colorMap = new Map();
    const colorMapString = cur.data("color-map");
    if (colorMapString) {
      colorMapString.split(',').forEach(pair => {
        const [number, hexColor] = pair.split(':');
        colorMap.set(number, hexColor);
      });
    }

    if (productTag) {
      $.get(
        "/search/suggest.json?type=product&q=variant_" +
          productTag +
          "&resources%5Boptions%5D%5Bfields%5D=tag",
        function (data) {
          var prodData = data.resources.results.products;
          var colorHtml = "";
          
          // Bijhouden van verwerkte URLs
          const processedUrls = new Set();

          $.each(prodData, function (index, product) {
            var url = "/products/" + product.handle;
            var productTags = product.tags;

            $.each(productTags, function (index, tag) {
              if (tag.indexOf("variant_") >= 0) {
                // Check of deze URL al is verwerkt
                if (processedUrls.has(url)) {
                  return; // Skip als de URL al bestaat
                }

                var tagSplit = tag.split("-");
                var variantColor = tagSplit[1];
                
                // Haal de hex kleur op uit de colorMap
                const hexColor = colorMap.get(variantColor) || '';
                let backgroundStyle = '';
                
                if (hexColor.includes('.SPLIT.')) {
                  const [color1, color2] = hexColor.split('.SPLIT.');
                  backgroundStyle = `background: linear-gradient(45deg, ${color1} 0%, ${color1} 50%, ${color2} 50%, ${color2} 100%)`;
                } else {
                  backgroundStyle = `background-color: ${hexColor}`;
                }

                colorHtml += `
                  <li class="splide__slide">
                    <a href="${url}" 
                       class="product-card-color color-block-${variantColor}"
                       style="${backgroundStyle}">
                    </a>
                  </li>`;
                
                // Voeg URL toe aan verwerkte URLs
                processedUrls.add(url);
              }
            });
          });

          // Voeg de HTML toe aan de slider
          cur.find('.splide__list').html(colorHtml);
          
          // Initialiseer de Splide slider
          if (colorHtml !== "") {
            new Splide(cur.find('.splide')[0], {
              perPage: 7,
              gap: '0px',
              pagination: false,
              // fixedWidth: 15,
              // fixedHeight: 15,
              arrows: true,
              drag: true,
              perMove: 3,
              breakpoints: {
                640: {
                  perPage: 5
                }
              }
            }).mount();
          }
        }
      );
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
    var wraps = document.querySelectorAll('[data-get-tags]');
    wraps.forEach(function (wrap) {
      // console.log(wrap)
      if (wrap) {
        toggleToItem(wrap);
      }
    });
});

document.querySelectorAll('[data-qb-variant]').forEach(el => {
  el.addEventListener('change', e => {
    var val = e.target.value;
    var selectedOption = e.target.options[e.target.selectedIndex];
    var imageCode = selectedOption.dataset.image;
    var imageImg = e.target.closest('.horizontal-product__inner')?.querySelector('img');

    // Change image upsell-product
    changeUpsellImages(e, selectedOption);

    // Change prices upsell-product
    changeUpsellPrices(e, selectedOption);

    const form = e.target.closest('form');
    if (form) {
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = val;
      }
      if (imageCode && imageImg) {
        console.log('imageCode == true: ', imageCode);
        imageImg.srcset = imageCode;
      }
    }
  });
});

function changeUpsellImages(e, selectedOption) {
  let { image } = selectedOption.dataset;
  let horizontalProductContainer = e.target.closest('.horizontal-product');

  if (image.includes('invalid')) return;

  if (e.target.closest('.x-drawer--upsell.xoxo')) {
    horizontalProductContainer = e.target.closest('.x-drawer--upsell.xoxo').querySelector('.product-info__modal-inner');
    image = image.replace(/width=\d+/, 'width=300');
  }

  if (!horizontalProductContainer) return;
  
  const currentImage = horizontalProductContainer.querySelector('img');
  currentImage.setAttribute('src', image);
  currentImage.setAttribute('srcset', image);    
}

function changeUpsellPrices(e, selectedOption) {
  let horizontalProductContainer = e.target.closest('.horizontal-product');
  if (e.target.closest('.x-drawer--upsell.xoxo')) {
    horizontalProductContainer = e.target.closest('.horizontal-product__cta');
  }

  const priceList = horizontalProductContainer?.querySelector('.price-list');
  const priceListPrice = priceList?.querySelector('sale-price');
  const priceListCompareAt = priceList?.querySelector('compare-at-price');

  const { oldPrice, newPrice } = selectedOption.dataset;

  if (oldPrice && priceListCompareAt) priceListCompareAt.innerHTML = oldPrice; 
  if (newPrice && priceListPrice) priceListPrice.innerHTML = newPrice;
}

document.addEventListener('change', function(event) {
  if (event.target.matches('select.product-tags-select')) {
    const curVal = event.target.value;
    const wrap = event.target.closest('[data-get-tags]');

    if (wrap && curVal) {
      const products = wrap.querySelectorAll('.horizontal-product .horizontal-product__inner');
      products.forEach(function(product) {
        if (product.dataset.activeTag == curVal) {
          const options = wrap.querySelectorAll('option[value="' + curVal + '"]');
          options.forEach(option => {
            option.selected = true;
          });
          product.classList.remove('hidden');
        } else {
          product.classList.add('hidden');
        }
      });
    }
  }
  if (event.target.matches('[data-qb-variant]')) {
    const curVal = event.target.value;
    const form = event.target.closest('form');

    if (form && curVal) {
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = curVal
      }
    }
  }
});

function toggleToItem(wrap) {
    if (!wrap.classList.contains('loaded')) {
      var variantTags = wrap.dataset.tags;
      var variantTagComplete = wrap.dataset.tagsComplete;

      if (variantTags) {
        $.get(
          "/search/suggest.json?type=product&q=" +
            variantTags +
            "&resources%5Boptions%5D%5Bfields%5D=tag",
          function (data) {
            var prodData = data.resources.results.products;

            prodData.sort((a, b) => {
              const aIsActive = a.tags.includes(variantTagComplete);
              const bIsActive = b.tags.includes(variantTagComplete);
              return bIsActive - aIsActive; 
            });
            
            var firstItem = true;
            $.each(prodData, function (index, product) {
              var url = "/products/" + product.handle;
              fetch(url) 
                .then(response => response.text())
                .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const targetHTMLFirstPull = doc.querySelector('#upsell__variants .horizontal-product').innerHTML;
                  const targetHTML = targetHTMLFirstPull.replace(/button--subdued/g, '');
                  
                  if (targetHTML) {
                    const tempContainer = document.createElement('div');
                    tempContainer.innerHTML = targetHTML;
                    const productDiv = tempContainer.querySelector('.horizontal-product__inner');
                    if (productDiv) {
                    productDiv.setAttribute('data-active-tag', product.id);
                    }

                    if (firstItem) {
                      firstItem = false;
                      wrap.innerHTML = '';
                    } else {
                      if (productDiv) {
                        productDiv.setAttribute('data-active-tag', product.id);
                        productDiv.classList.add('hidden');
                      }
                    }
                      wrap.insertAdjacentHTML('beforeend', tempContainer.innerHTML);
                  }
                }).then(data => {
                  tagToggleLoad();
                });
            });
            wrap.classList.add('loaded');
            wrap.querySelectorAll('.button--sm').forEach((button) => {
              console.log(button);
              button.classList.remove('button--subdued');
            });
          }
        );
      }

    }
  }

  function tagToggleLoad() {
    document.querySelectorAll('.product-tags-select').forEach(function (e) {
      var cur = $(e);
      var variantTags = cur.attr("data-tags");
      // var variantSettings = cur.attr("data-variant-setting");
      var variantTagComplete = cur.attr("data-tags-complete");
      // var dataQbVariantTag = cur.attr('data-qb-variant-tag');
      
      if (variantTags) {
        $.get(
          "/search/suggest.json?type=product&q=" +
            variantTags +
            "&resources%5Boptions%5D%5Bfields%5D=tag",
          function (data) {
            var prodData = data.resources.results.products;
            var productHtml = "";
            // var optionsHtml = '';

            // Sorteer de producten zodat de actieve variant eerst komt
            prodData.sort((a, b) => {
              const aIsActive = a.tags.includes(variantTagComplete);
              const bIsActive = b.tags.includes(variantTagComplete);
              return bIsActive - aIsActive; // Active items komen eerst
            });
            
            // Bijhouden van verwerkte kleur URLs
            // const processedColorUrls = new Set();

            $.each(prodData, function (index, product) {
              // console.log(index, product);
                // var url = "/products/" + product.handle;
                productHtml += '<option value="'+ product.id +'" data-upsell-variant="'+ product.url +'">'+ product.title +'</option>';
            });

            cur.html(productHtml);
            cur.addClass("loaded");
          }
        );
      }
    });
  }

function loadVariantProducts() {
  var variantTags = $(".product-tags").attr("data-tags");
  var variantSettings = $(".product-tags").attr("data-variant-setting");
  var variantTagComplete = $(".product-tags").attr("data-tags-complete");
  // Parse de color map
  const colorMap = new Map();
  const colorMapString = $(".product-tags").attr("data-color-map");
  if (colorMapString) {
    colorMapString.split(',').forEach(pair => {
      const [number, hexColor] = pair.split(':');
      colorMap.set(number, hexColor);
    });
  }

  if (variantTags) {
    $.get(
      "/search/suggest.json?type=product&q=" +
        variantTags +
        "&resources%5Boptions%5D%5Bfields%5D=tag",
      function (data) {
        // console.log('data:', data);
        var prodData = data.resources.results.products;
        var completeHtml = "";
        var productHtml = "";

         // Sorteer de producten zodat de actieve variant eerst komt
         prodData.sort((a, b) => {
          const aIsActive = a.tags.includes(variantTagComplete);
          const bIsActive = b.tags.includes(variantTagComplete);
          return bIsActive - aIsActive; // Active items komen eerst
        });
        
        // Bijhouden van verwerkte kleur URLs
        const processedColorUrls = new Set();

        $.each(prodData, function (index, product) {
          if (variantSettings == "images") {
            var url = "/products/" + product.handle;
            productHtml += '<li class="splide__slide">';
            // productHtml += '<a class="variant-inner" href="' + url + '">';
            productHtml += '<a class="variant-inner ' + (product.tags.includes(variantTagComplete) ? 'active' : '') + '" href="' + url + '">';
            productHtml += '<img src="' + product.image + '" width="1000" height="1000" />';
            productHtml += "</a>";
            productHtml += "</li>";
          } else {
            var productTags = product.tags;
            $.each(productTags, function (index, tag) {
              if (tag.indexOf("variant_") >= 0) {
                var tagSplit = tag.split("-");
                var variantColor = tagSplit[1];
                var colorUrl = "/products/" + product.handle;
                
                // Check of deze kleur URL al is verwerkt
                if (processedColorUrls.has(colorUrl)) {
                  return; // Skip deze kleur als de URL al bestaat
                }
                
                const hexColor = colorMap.get(variantColor) || '';
                let backgroundStyle = '';
                
                if (hexColor.includes('.SPLIT.')) {
                  const [color1, color2] = hexColor.split('.SPLIT.');
                  backgroundStyle = `background: linear-gradient(45deg, ${color1} 0%, ${color1} 50%, ${color2} 50%, ${color2} 100%)`;
                } else {
                  backgroundStyle = `background-color: ${hexColor}`;
                }

                productHtml += '<li class="splide__slide">';
                productHtml +=
                  '<a class="color-block color-block-' +
                  variantColor +
                  '" href="' +
                  colorUrl +
                  '" style="' + backgroundStyle + '">';
                productHtml += "</a>";
                productHtml += "</li>";
                
                // Voeg de kleur URL toe aan verwerkte URLs
                processedColorUrls.add(colorUrl);
              }
            });
          }
        });

        completeHtml += productHtml;
        $(".sm-variants-wrap .splide__list").html(completeHtml);
        $(".variants-slider").addClass("loaded");
        mountVariantSlider();
      }
    );
  }
}

function mountVariantSlider() {
  var variantSlider = $(".productpage-tags");
  var variantSettings = $(".product-tags").attr("data-variant-setting");
  var fixedWidth = 1;
  var fixedHeight = 1;

  if (variantSettings == "images") {
    fixedWidth = 75;
    fixedHeight = 75;
  } else if (variantSettings == "colors") {
    fixedWidth = 30;
    fixedHeight = 30;
  }

  if (variantSlider.length > 0) {
    const variantsSlider = new Splide(".variants-slider", {
      type: "slide",
      // perPage: 7,
      gap: 10,
      pagination: false,
      fixedWidth: fixedWidth,
      fixedHeight: fixedHeight,
      speed: 700,
      perMove: 3,
      drag: true,
      loop: false,
      arrows: true,
      breakpoints: {
        767: {
          perPage: 4,
        },
      },
    });

    variantsSlider.on("overflow", function (isOverflow) {
      if (!isOverflow) {
        variantsSlider.options = {
          arrows: false,
          drag: false,
        };
      }
    });

    variantsSlider.mount();
  }
}

// PROMO COUNTDOWN SECTION
const PromoCountdown = class extends HTMLElement {
  connectedCallback() {
    console.log("PromoCountdown connected");
  }
};

if (!window.customElements.get("promo-countdown")) {
  window.customElements.define("promo-countdown", PromoCountdown);
}

// Filterinformation
class FilterInformation extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.btn = this.querySelector('.filter-information__btn');
    this.tooltip = this.querySelector('.filter-information__tooltip');
    
    this.btn.addEventListener('click', e => {
      e.stopPropagation();
      
      this._toggle();
    })
    
    this.tooltip.addEventListener('click', e => e.stopPropagation());
    
    document.addEventListener('click', () => this._close());
  }
  
  disconnectedCallback() {
    document.removeEventListener('click', () => this._close());
  }
  
  _toggle() {
    const isOpen = this.tooltip.classList.contains('visible');

    document.querySelectorAll('.filter-information__tooltip').forEach(t => {
      if (t !== this.tooltip) t.classList.remove('visible');
    });

    
    if (!isOpen) {
      this.tooltip.classList.add('visible');
    }
  }

  _close() {
    this.tooltip.classList.remove('visible');
  }
}

customElements.define('filter-information', FilterInformation);